<div class="container-fluid px-0">
    <div class="row">
        <div class="col-xl-12">
            <div class="card h-100">
                <div class="card-header">
                    <!-- toolbar -->

                    <div class="btn-group shadow-lg" style="border-radius: 10px;">
                        <button class="btn" (click)="cambiarMes(-1)">
                            <i class="fas fa-chevron-left"></i> Anterior
                        </button>
                        <span class="btn">{{ obtenerNombreMes(mesActual.getMonth()) | uppercase }}</span>
                        <button class="btn" (click)="cambiarMes(1)">
                            Siguiente <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>

                </div>
                <div class="card-body">
                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                        (pageChange)="search()"></ngb-pagination>
                    <div class="table-responsive">
                        <table class="table user-list">
                            <thead>
                                <tr>
                                    <th><span>NOMBRE</span></th>
                                    <th><span>RUT</span></th>
                                    <th><span>VEHÍCULO</span></th>
                                    <th><span>FECHA INGRESO</span></th>
                                    <th><span>FECHA SALIDA</span></th>
                                </tr>
                            </thead>
                            <tbody *ngIf="items?.length>0; else noData">
                                <tr *ngFor="let item of items">
                                    <td>
                                        <span>{{item?.name | uppercase}} {{item?.lastname | uppercase}}</span><br>
                                        <small class="badge bg-info" *ngIf="item?.access_type">Acceso {{item.access_type | titlecase}}</small>
                                    </td>
                                    <td>
                                        <span>{{item.rut | uppercase}}</span>
                                    </td>
                                    <td>
                                        <span class="badge bg-secondary" *ngIf="item?.access_type === 'Peatonal'">Peatonal</span>
                                        <ng-container *ngIf="item?.access_type !== 'Peatonal'">
                                            <span *ngIf="item?.cars_ppu">
                                                {{item.cars_ppu | uppercase}}
                                                <br>
                                                <small *ngIf="item?.cars_type?.tag">{{item.cars_type.tag | uppercase}}</small>
                                            </span>
                                            <span class="badge bg-warning" *ngIf="!item?.cars_ppu">No registra</span>
                                        </ng-container>
                                    </td>

                                    <td>
                                        <span>{{item?.date_ing}}</span>
                                    </td>
                                    <td>
                                        <span>{{item.date_out}}</span>
                                    </td>                   
                                </tr>

                            </tbody>
                            <ng-template #noData>
                                <tbody>
                                    <td colspan="7" class="fw-lighter text-muted">No se encontraron Registros</td>
                                </tbody>
                            </ng-template>
                        </table>
                    </div>
                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                    (pageChange)="search()"></ngb-pagination>
                </div>
            </div>
        </div>
    </div>

</div>
<ng-template #searchRut let-c="close" let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-search-record (selected)="d('Cross click')" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>